import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=0e2c48e7"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src724620054/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e2c48e7')) {
      api.createRecord('0e2c48e7', component.options)
    } else {
      api.reload('0e2c48e7', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=0e2c48e7", function () {
      api.rerender('0e2c48e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/portals/Administration/Categories/Form.vue"
export default component.exports